/**
 * Canal leve entre qualquer parte do app e o diálogo de feedback / micro-pesquisa
 * montados no FeedbackButton (#floating-actions dos layouts).
 */
import type { AvaliacaoEvento, FeedbackTipo } from '@patrociconnect/shared';

export interface FeedbackPrefill {
  tipo?: FeedbackTipo;
  /** Mensagem de erro exibida ao usuário (anexada como informação técnica) */
  erroMensagem?: string;
  correlationId?: string;
  /** id da ocorrência de erro do frontend já enviada */
  erroId?: string;
}

type OpenListener = (prefill: FeedbackPrefill) => void;
type SurveyListener = (evento: AvaliacaoEvento) => void;

const openListeners = new Set<OpenListener>();
const surveyListeners = new Set<SurveyListener>();

/** Chave em sessionStorage: sobrevive à troca de layout (ex.: cadastro → dashboard) */
export const PENDING_SURVEY_KEY = 'pc:microSurvey:pending';

export function onOpenFeedback(listener: OpenListener): () => void {
  openListeners.add(listener);
  return () => openListeners.delete(listener);
}

export function hasFeedbackListener(): boolean {
  return openListeners.size > 0;
}

export function openFeedback(prefill: FeedbackPrefill = {}): void {
  openListeners.forEach((listener) => listener(prefill));
}

export function onMicroSurvey(listener: SurveyListener): () => void {
  surveyListeners.add(listener);
  return () => surveyListeners.delete(listener);
}

export function requestMicroSurvey(evento: AvaliacaoEvento): void {
  try {
    sessionStorage.setItem(PENDING_SURVEY_KEY, evento);
  } catch {
    // Sem sessionStorage a pesquisa ainda aparece se o host já estiver montado
  }
  surveyListeners.forEach((listener) => listener(evento));
}
